// extracted by mini-css-extract-plugin
export default {"container":"Language_container__8210Q","icon":"Language_icon__FnFNe","title":"Language_title__5or6l","switchContainer":"Language_switchContainer__7SQDZ"};